import React from 'react';
import {
  AddIssueForm,
  PageContainerWrapper,
} from '../../../../components';
import { useTranslation } from 'react-i18next';
import { backToPage } from '../../../../utils';
import { useNavigate } from 'react-router-dom';
import { accessRoute } from '../../../../routes/Reports/index';
import useSubmit from '../../../../hooks/useSubmit.hook';
import { addIssueBreadcrumb } from '../../../../services/Columns';
import { addIssueService } from '../../../../services/index.service';
export default function AddIssue() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectUrl = accessRoute.REPORT_AN_ISSUE.path;
  const breadcrumb = addIssueBreadcrumb();
  const [onSubmit, , isLoading] = useSubmit({
    service: addIssueService,
    afterSubmitActionType: 'redirect',
    redirectUrl,
  });

  return (
    <div className="wide-md mx-auto">
      <PageContainerWrapper
        breadcrumb={breadcrumb}
        btnArray={['extraButton']}
        extraBtnText={t('text.common.back')}
        extraBtnClass="btn btn-outline-light bg-white"
        onExtraButtonHandleShow={() => backToPage(navigate, redirectUrl)}
        heading={t('text.report.addIssue')}
      >
        <div className="nk-block">
          <div className="card">
            <div className="card-inner">
              <AddIssueForm
                onSubmit={onSubmit}
                isLoading={isLoading}
                backToPage={() => backToPage(navigate, redirectUrl)}
              />
            </div>
          </div>
        </div>
      </PageContainerWrapper>
    </div>
  );
}
